import _ from "lodash";
import {
  getAttachmentGroupsOfNodeFromCache,
  writeAttachmentGroupsOfNodeInCache,
} from "./StudentAssignmentGraphqlHelpers";
import { createAttachmentGroupsMutationV2 } from "./StudentAssignmentMutations";
import client from "lib/apolloClient/client";
import { ATTACHMENT_WARNINGS } from "Utils";
import { setToastMsg } from "Login/modules/LoginModule";
import { dispatchError } from "Utils/dispatchError";

export const createAttachmentGroupsV2 = ({ input, portalType }) => {
  return async dispatch => {
    try {
      if (input.parentId) {
        const result = await client.mutate({
          mutation: createAttachmentGroupsMutationV2,
          variables: {
            input,
            portalType,
          },
          update: (
            cache,
            {
              data: {
                platform: { createAttachmentGroupsV2 },
              },
            }
          ) => {
            const { parentId } = input;

            const nodeDetails = getAttachmentGroupsOfNodeFromCache({
              id: parentId,
            });

            const response = _.get(
              createAttachmentGroupsV2,
              "0.response",
              null
            );

            if (!response) return;

            const attachmentGroups =
              _.get(nodeDetails, "attachmentGroups", []) || [];

            const newAttachmentGroup = [response];

            const data = {
              ...nodeDetails,
              attachmentGroups: [...attachmentGroups, ...newAttachmentGroup],
            };

            writeAttachmentGroupsOfNodeInCache({
              id: parentId,
              data,
            });
          },
        });

        const resArray = _.get(
          result,
          "data.platform.createAttachmentGroupsV2",
          []
        );

        const response = _.get(resArray, ["0", "response"]);

        if (!response) {
          const errorCode = _.get(resArray, ["0", "warning", "errorCode"]);
          const errorText = _.get(ATTACHMENT_WARNINGS, errorCode, "");
          if (errorText) {
            dispatch(
              setToastMsg({
                msg: errorText,
              })
            );
            return [];
          }
          dispatch(setToastMsg("toastMsgs:something_went_wrong"));
          return [];
        }
        return [response];
      } else {
        dispatch(setToastMsg("toastMsgs:something_went_wrong"));
      }
    } catch (err) {
      console.error(err);
      dispatchError({ dispatch, e: err });
      return [];
    }
  };
};
